import Page from "../components/Page"
import errorImage from "../assets/images/error-cat.png"

/**
 * Display this page if we receive a bad API response or other errors when loading a page.
 */
const ErrorPage = () => {

    return (
        <Page>
            <h1>Something went wrong...</h1>
            <img src={errorImage} alt="Image of cat knocking over a flower pot and tables" style={{width:200, height:200}}/>
            <p>The page you requested failed to load. Please refresh the page to try again.</p>
        </Page>
    );
};

export default ErrorPage;